"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';

var index = function index(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  }

  throw new Error(prefix + ': ' + (message || ''));
};

var _default = index;
exports["default"] = _default;